enum CallStatusEnum {
  InCall = 'InCall',
  OpenCall = 'OpenCall'
}

export default CallStatusEnum;
